module.exports = __webpack_public_path__ + "media/fonts/fa-brands-400-d3b6d1f7e7658083c6eadbc50496d598.svg";